import { useState } from "react";

const commonFields = [
  "purchaseOrderNumber",
  "dueDate",
  "dueUpto",
  "gstType",
  "paymentInstruction",
  "scopeNotes",
];
const fieldsByType = {
  invoice: [
    "invoiceNumber",
    "contactID",
    "recipientEmail",
    "invoiceType",
    "quotationID",
    "invoiceDate",
    "terms",
    "scheduleRetention",
  ],
  rcti: [
    "rctiNumber",
    "supplierID",
    "rctiDate",
    "supplyDate",
    "supplierNotes",
    "rctiNotes",
    "adjustmentReason",
    "paymentDate",
    "paymentMode",
    "paymentTransactionID",
    "paymentAmount",
    "recurring",
  ],
};
const itemFields = [
  "itemID",
  "itemName",
  "itemDescription",
  "categoryCodeName",
  "itemPrice",
  "itemQuantity",
  "gst",
  "discountType",
  "discountValue",
  "discountAmount",
];
const numericFields = new Set([
  "itemPrice",
  "itemQuantity",
  "gst",
  "discountValue",
  "discountAmount",
]);

function draftSignature(type, values, items) {
  const fields = [...commonFields, ...fieldsByType[type]].map((field) => {
    const value = values[field] ?? "";
    if (field.endsWith("Date") && value) {
      const date = new Date(value);
      return [
        field,
        Number.isNaN(date.getTime()) ? String(value) : date.toISOString(),
      ];
    }
    return [field, value];
  });
  const rows = items
    .filter((item) => item.itemID || item.itemName?.trim() || item.itemDescription?.trim())
    .map((item) =>
      itemFields.map((field) => {
        const value = item[field] ?? "";
        return numericFields.has(field) && value !== "" ? Number(value) : value;
      })
    );
  return JSON.stringify([fields, rows]);
}

export default function useDraftDocumentState({
  type,
  id,
  values,
  items,
  documents,
  saving,
}) {
  const [savedSignature, setSavedSignature] = useState(null);
  const signature = draftSignature(type, values, items);
  const hasSavedDocument = Boolean(id);
  const hasUnsavedChanges =
    savedSignature !== signature || documents.some((document) => document.file);
  const markSaved = (savedValues = values, savedItems = items) => {
    setSavedSignature(draftSignature(type, savedValues, savedItems));
  };
  return {
    hasSavedDocument,
    hasUnsavedChanges,
    canUseDocumentActions: hasSavedDocument && !hasUnsavedChanges && !saving,
    markSaved,
  };
}
